// material ui components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// components
import Button from "../../../common/button";

// styles
import styles from "./styles.module.css";
import { BUTTON, NOCARD } from "./constants";

// constants

interface Props {
  handleClick: () => void;
}

const NoCard = ({ handleClick }: Props) => {
  return (
    <Box className={styles["container"]}>
      <Box
        component="img"
        src="/assets/images/svg/debitCard.svg"
        className={styles["image_container"]}
      />
      <Box className={styles["text_wrapper"]}>
        <Typography className={styles["header"]}>{NOCARD.NO_WAY}</Typography>
        <Typography className={styles["desc"]}>{NOCARD.ADD_BANK}</Typography>
      </Box>

      <Box onClick={handleClick} className={styles["button_wrapper"]}>
        <Button>{BUTTON.ADD_ACCOUNT}</Button>
      </Box>
    </Box>
  );
};

export default NoCard;
